import { useNavigate, useParams, useSearch } from '@tanstack/react-router';

import ChatHistoryPage from '@/features/votes/ChatHistoryPage';
import { useResolveVote } from '@/features/votes/useMessageVotes';

export default function ChatVoteByChatPage() {
  const route = '/message-votes/by-chat/$chatId/$messageId/$userId' as const;
  const { chatId, messageId, userId } = useParams({ from: route });
  const search = useSearch({ from: route });
  const navigate = useNavigate({ from: route });
  const {
    data: voteId,
    isLoading,
    error,
  } = useResolveVote(chatId ?? '', messageId ?? '', userId ?? '');

  if (isLoading) {
    return (
      <div className="flex h-dvh w-full items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }
  if (error || !voteId) {
    return (
      <div className="flex h-dvh w-full items-center justify-center bg-background text-muted-foreground">
        No vote found for this chat
      </div>
    );
  }
  return (
    <ChatHistoryPage
      voteId={voteId}
      isDiscussionOpen={search.discussion}
      onDiscussionOpenChange={(discussion) =>
        navigate({
          search: { ...search, discussion },
          replace: !discussion,
        })
      }
      onBack={() =>
        navigate({
          to: '/message-votes',
          search: search.returnTo ?? undefined,
        })
      }
    />
  );
}
